import { chain } from 'lodash';

import { UrlAttributes } from './types';

export const toUrlParams = (attributes: UrlAttributes): string => {
  return chain(attributes)
    .transform((acc: string[], value, key) => {
      try {
        if (value === '') {
          return acc;
        }

        return acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`);
      } catch (_err) {
        return acc;
      }
    }, [])
    .join('&')
    .value();
};
